import { render, staticRenderFns } from "./backstage.vue?vue&type=template&id=d5742f38"
import script from "./backstage.vue?vue&type=script&lang=js"
export * from "./backstage.vue?vue&type=script&lang=js"
import style0 from "./backstage.vue?vue&type=style&index=0&id=d5742f38&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports